import { newAPI } from '../../../services';
import qs from 'qs';

export const fetchCashFlow = async url => {
  const response = await newAPI.get(url);
  return response.data;
}

export const fetchCashFlowResume = async (userId, startDate, endDate) => {
  const response = await newAPI.get(`${userId}/financial/totals?startDate=${startDate}&endDate=${endDate}`);
  return response.data;
}

export const fetchFinancialResume = async url => {
  const response = await newAPI.get(url);
  return response.data;
}

export const fetchUsageResume = async url => {
  const response = await newAPI.get(url);
  return response.data;
}

export const fetchAllEstablishmentsFinancialAndUsageResume = async (userId, params) => {
  const response = await newAPI.post(`${userId}/reports/multi-establishment`, qs.stringify(params));
  return response.data;
}

export const fetchAllEstablishmentsFinancialAndUsageResumeList = async userId => {
  const response = await newAPI.get(`${userId}/reports/multi-establishment/list`);
  return response.data;
}

export const fetchAllEstablishmentsFinancialAndUsageResumeReport = async (userId, reportId) => {
  const response = await newAPI.get(`${userId}/reports/multi-establishment/${reportId}/data`);
  return response.data;
}

export const fetchAllCompletedEstablishmentsFinancialAndUsageResumeReport = async (userId, reportId) => {
  const response = await newAPI.get(`${userId}/reports/multi-establishment/completed/${reportId}`);
  return response.data;
}